/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import {
  CheckoutV2Api,
  ClientPreferences,
  Contact,
  ContactNode,
  ContactNodeRequest,
  V2CreateSessionResponse,
  V2PaymentPrepareRequest,
  V2PaymentRequest,
  V2PaymentResponse
} from '@api';
import { PurchaseItem } from 'src/js/model/index';
import { DefaultHttpService } from '../../common/services/HttpService';
import { CartState, IshState } from '../../services/IshState';
import { State as SummaryState } from '../containers/summary/reducers/State';
import { BuildContactNodeRequest } from './CheckoutService';
import { ContactNodeService } from './ContactNodeService';

class CheckoutApiService {
  readonly checkoutApi: CheckoutV2Api = new CheckoutV2Api(new DefaultHttpService());

  public getClientPreferences(): Promise<ClientPreferences> {
    return this.checkoutApi.getClientPreferences()
  }

  public createSession(body: V2PaymentPrepareRequest,  payerId: string, deprecatedSessionId?: string): Promise<V2CreateSessionResponse> {
    return this.checkoutApi.createSession(body, payerId, window.location.origin, deprecatedSessionId);
  }

  public submitCreditCardPayment(body: V2PaymentRequest, payerId: string): Promise<V2PaymentResponse> {
    return this.checkoutApi.submitCreditCardPayment(body, window.location.origin + window.location.pathname, payerId);
  }

  public submitPayment(body: V2PaymentPrepareRequest, payerId: string): Promise<V2PaymentResponse> {
    return this.checkoutApi.submitPayment(body, payerId);
  }

  public getStatus(sessionId: string): Promise<V2PaymentResponse> {
    return this.checkoutApi.getStatus(sessionId);
  }

  public getContactNode = (contact: Contact, summary: SummaryState, cart: CartState, payerId: string): Promise<ContactNode> => this.checkoutApi.getContactNodeV2(BuildContactNodeRequest.fromContact(contact, summary, cart, payerId));

  public getContactNodeForCart = (params: ContactNodeRequest): Promise<ContactNode> => this.checkoutApi.getContactNodeV2(params);

  public updateItem = (item: PurchaseItem, state: IshState): Promise<PurchaseItem> => {
    if (item.selected) {
      const request: ContactNodeRequest = BuildContactNodeRequest.fromPurchaseItem(item, state);
      return this.checkoutApi.getContactNodeV2(request)
        .then((data) => Promise.resolve(ContactNodeService.getPurchaseItem(data, item)))
        .catch((e) => Promise.reject(e));
    }
    return Promise.resolve(item);
  };

  public getContactNodeByNodeRequest = (request: ContactNodeRequest): Promise<ContactNode> => this.checkoutApi.getContactNodeV2(request);
}

export default new CheckoutApiService();
